uniform vec3 twistDirection;

varying vec3 vFakeUVW; //used for texture map cube lookup
varying vec4 vPosition; // raw values after twist in model space
varying vec4 vPos; // times modelViewMatrix 
varying vec4 vPosProj; // times projection matrix
varying vec3 vNormal; // raw values after twist 
varying vec3 vNorm; //times normal matrix
varying vec3 vNormMod; // times modelMatrix
varying vec3 vWorldNormal; //times modelViewMatrix
varying vec3 vEyeVec; // vertexWorldPosition - cameraPosition

const float PI = 3.141592653;
const float twistAmount = 1.0;

mat4 rotationMatrix(vec3 axis, float angle) {
    axis = normalize(axis);
    float s = sin(angle);
    float c = cos(angle);
    float oc = 1.0 - c;
    float xs = axis.x * s;
    float ys = axis.y * s;
    float zs = axis.z * s;
    return mat4(oc * axis.x * axis.x + c,   oc * axis.x * axis.y - zs,  oc * axis.z * axis.x + ys,  0.0,
                oc * axis.x * axis.y + zs,  oc * axis.y * axis.y + c,   oc * axis.y * axis.z - xs,  0.0,
                oc * axis.z * axis.x - ys,  oc * axis.y * axis.z + xs,  oc * axis.z * axis.z + c,   0.0,
                0.0,                        0.0,                        0.0,                        1.0);
}

void main() {    
    vec3 dir = normalize(twistDirection); // +- xyz
    float dist = dot(dir, position.xyz);  // distance of vertex along the twist direction
    float twistProp = twistAmount * (-PI / 2.0 * (dist + 0.5));  // amount of rotation around the twist direction
    mat4 roatation = rotationMatrix(dir, twistProp);  

    vFakeUVW = position;
    vPosition = roatation * vec4(position, 1.0);

    vNormal = vec4(roatation * vec4( normal, 0.0)).xyz;
    vWorldNormal = normalize( modelViewMatrix * vec4(normal, 0.0)).xyz;

    vec4 worldPosition = modelMatrix * vPosition; 
	vEyeVec = normalize(worldPosition.xyz - cameraPosition * .7);


    vPos = modelViewMatrix * vPosition; 
    vNorm = normalMatrix * vNormal; 
    vPosProj = projectionMatrix * vPos;
    vNormMod = vec3(modelMatrix  * vec4(vNormal, 0.0)).xyz;

    gl_Position = vPosProj;
}

